<template lang="pug">
  section(:class="[ page, transitionName, {'loading': loading }]")#app
    #overlay
      Spinner#spinner
    Header(:class="{'scrolled': scrolled}", :cover="cover[page]", :navSocial="cover.navSocial")
    transition(:name="transitionName", mode="out-in", :duration="{ enter: 100, leave: 100 }")
      router-view
</template>

<script>
import {mapState} from 'vuex'
import Header from '@/components/Header/index.vue'
import Spinner from '@/assets/svg/spinner.svg'
import '@/styles/app.sass'

export default {
  name: 'app',
  components: {
    Header,
    Spinner
  },
  data: () => ({
    scrolled: false,
    page: 'home',
    transitionDefault: 'slide-left',
    transitionName: 'slide-left'
  }),
  computed: {
    ...mapState({
      cover: state => state.cover,
      loading: state => state.app.loading
    })
  },
  methods: {
    handleScroll () {
      this.scrolled = window.scrollY > 50
    }
  },
  watch:{
    $route (to, from) {
      // loading show
      this.$store.commit('setLoading', true)
      // change page class
      this.page = to.name

      if (from.name === null || to.name === 'home') {
        this.transitionName = 'fade'
      } else if (from.name === 'home' || to.name === 'notFound' || from.name === 'notFound') { 
        this.transitionName = 'slide-top'
      } else {
        this.transitionName = this.transitionDefault
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted () {
    this.$store.commit('setLoading', false)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
